import { EXPERTS_MASTER, composeExpert, DEFAULT_EXPERT_STATS } from './experts'
import { EXPERT_CASES } from './cases'
import { SCORING_CONFIG } from './adminConfig'

/**
 * 向后兼容：从主数据生成完整专家对象（含派生数据）
 * 运行时会由 store 重新初始化，此处仅保证直接 import { EXPERTS } 的兼容性
 */
export const EXPERTS = EXPERTS_MASTER.map(master =>
  composeExpert(master, { ...DEFAULT_EXPERT_STATS }, EXPERT_CASES, SCORING_CONFIG)
)

/** 向后兼容：重新导出案例数据 */
export { EXPERT_CASES }

export const TOPICS = [
  {
    id: '1',
    title: '下属执行力差，推一下动一下',
    type: '战友最痛',
    isTop10: true,
    isHot: true,
    relatedIds: ['7', '8'],
    caseStudy: "某互联网大厂主管发现团队进度总是'前松后紧'。他取消了周报，改为'日清看板'：每日下班前，成员需在大群同步'今日核心交付'与'明日卡点预判'。主管不再问'为什么慢'，而是问'我能支持你什么'。通过颗粒度对齐和即时赋能，团队从'推一下动一下'转变为'自驱动冲刺'，项目交付率在双月内提升了 35%。",
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '2',
    title: '跨部门协作难，对方不配合',
    type: '战友最痛',
    isTop10: true,
    isHot: true,
    relatedIds: ['5', '10'],
    caseStudy: "IT部与业务部长期撕逼：一个怨需求乱，一个嫌开发慢。IT负责人主动发起'影子轮岗'，让核心开发去一线观察业务流程。同时，双方建立'联合战队'，将系统稳定性和业务转化率挂钩，背负共同KPI。通过这种'利益捆绑'与'体感对齐'，跨部门协作的摩擦系数大幅降低，核心系统上线周期缩短了 30%。",
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '3',
    title: '核心骨干突然离职，如何应对',
    type: '战友最痛',
    isTop10: true,
    isHot: true,
    relatedIds: ['9', '6'],
    caseStudy: "核心架构师提出离职，主管没有第一时间谈钱，而是发起了一场'深度职涯复盘'。发现对方离职并非为了高薪，而是对技术边缘化感到恐慌。主管随即为他申请了'首席专家'虚拟头衔，并划拨专项预研经费。同时启动人才备份计划，安排两名高潜进行技术继承。这种'尊重+授权'的组合拳，不仅成功挽留了骨干，还倒逼了团队的技术沉淀。",
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '4',
    title: '新晋管理者如何建立威信',
    type: '战友最痛',
    isTop10: true,
    isHot: true,
    relatedIds: ['10', '1'],
    caseStudy: "技术大牛刚转管理，老部下不买账。他采取了'三步立威'：首先，带队攻克了一个无人敢接的陈年 Bug，确立'专家威信'；其次，私下一对一面谈，明确团队奖惩红线，确立'制度威信'；最后，在分配奖金时坚持'透明且拉开差距'。半年后，团队完成了从'个人英雄'到'组织领袖'的权力平稳过渡。",
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '5',
    title: '会议效率低，议而不决',
    type: '战友最痛',
    isTop10: true,
    isHot: true,
    relatedIds: ['2', '8'],
    caseStudy: "某传统企业周会动辄 3 小时。新任 CEO 推行'会议三不'：无议程不启动、无决策不散会、无纪要不留存。会议前分发背景材料，严禁现场宣读文档。引入'站立会议'机制，限定议题 15 分钟内表态。改革后，平均会议时长缩短至 45 分钟，决策执行率提升 50%，高效的沟通文化迅速渗透进组织神经末梢。",
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '6',
    title: '如何给下属做绩效面谈',
    type: '组织必修',
    isTop10: true,
    isHot: true,
    relatedIds: ['9', '3'],
    caseStudy: '某金融公司主管在绩效面谈中经常陷入"尬聊"。他引入了"汉堡包反馈法"：先肯定优点，再指出具体改进点，最后表达信心。在谈及改进点时，他不再使用模糊的形容词，而是引用具体的业务数据和行为案例。同时，他将面谈重心从"审判过去"转向"规划未来"，与下属共同制定下一季度的个人成长计划。这种基于事实与发展的面谈方式，让员工感受到了尊重与支持，绩效改进的达成率提升了35%。',
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '7',
    title: '团队目标对齐与压力传递',
    type: '组织必修',
    isTop10: true,
    isHot: true,
    relatedIds: ['1', '8'],
    caseStudy: '某电商团队在双11大促前，目标感缺失。负责人组织了一场"目标共创会"，让每位成员讨论大目标与个人工作的关联。通过"压力层层穿透"，每个小组都领到了清晰的"战地指标"。同时，负责人设立了"压力仪表盘"，实时同步全员进度，并建立"互助小组"解决瓶颈。最终，团队不仅超额完成了销售目标，且成员在极高压环境下展现出了前所未有的战斗力，实现了组织目标与个人成长的双赢。',
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '8',
    title: '管理者的时间管理与授权',
    type: '组织必修',
    isTop10: true,
    isHot: true,
    relatedIds: ['1', '7'],
    caseStudy: '一位事必躬亲的经理每天加班到深夜，团队却怨声载道。在教练的指导下，他开始应用"四象限法则"重新梳理工作，并将80%的事务性工作授权给下属。在授权过程中，他遵循"授能不授责"的原则，提供必要的资源支持但不干预具体过程。他腾出精力关注战略思考与人才培养。结果，他自己的工作时间减少了30%，而下属因为得到了锻炼机会，能力提升极快，团队整体产出反而增长了25%。',
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '9',
    title: '如何识别与培养高潜人才',
    type: '组织必修',
    isTop10: true,
    isHot: true,
    relatedIds: ['3', '6'],
    caseStudy: '某快消企业通过"九宫格人才评估法"重新盘点人才库。他们不仅关注当前的业绩产出，更引入了"学习敏锐度"和"抱负水平"等潜力指标。对于识别出的高潜人才，公司量身定制了"旋转门计划"，让他们在不同核心业务部门轮岗锻炼。同时，每位高潜人才都配备了一名高管导师。通过这种系统化的识别与培养，公司在两年内实现了管理层80%的内部提拔率，极大地稳定了核心人才队伍。',
    publishStatus: 'published',
    sortWeight: 0,
  },
  {
    id: '10',
    title: '从技术骨干向管理者的转型',
    type: '组织必修',
    isTop10: true,
    isHot: true,
    relatedIds: ['4', '2'],
    caseStudy: '一名资深架构师被提拔为总监后，初期非常痛苦，总想替下属写代码。他参加了"管理转型工作坊"，意识到自己的核心价值已从"解决技术难题"转变为"打造解决难题的团队"。他开始刻意练习"非技术性沟通"，学习如何通过目标设定和文化建设来驱动团队。他建立了技术分享机制，鼓励成员自主决策。一年后，他成功完成了心态与能力的双重转型，他带领的部门成为了公司公认的"人才黄埔军校"。',
    publishStatus: 'published',
    sortWeight: 0,
  },
]

export const SCENARIO_DATA = {
  '1': {
    id: 's1',
    description: '你安排了一项重要任务，但下属反馈消极，进度缓慢。',
    practiceCount: 1234,
    accuracyRate: 78,
    options: [
      { id: 'o1', text: '严厉批评，要求立即完成', isError: true, feedback: '❗ 可能会引起反弹，导致关系紧张。' },
      { id: 'o2', text: '询问困难，共同寻找解决方案', isError: false, feedback: '✔ 有助于建立信任，找到问题根源。' },
      { id: 'o3', text: '自己动手做，不指望他', isError: true, feedback: '❗ 管理者的大忌，会导致团队依赖。' }
    ]
  },
  't1': {
    id: 's3',
    description: '【绩效宣贯】公司近期调整了研发部门的组织架构（见下图）。作为主管，你发现小陈由于汇报线变更，产生了严重的抵触情绪。\n[img]https://img.freepik.com/free-vector/org-chart-concept-illustration_114360-6428.jpg[/img]\n面对这种情况，你准备如何沟通？',
    practiceCount: 2156,
    accuracyRate: 65,
    options: [
      { id: 'o1', text: '"这是公司的战略决定，你只要把代码写好就行了。"', isError: true, feedback: '❗ 典型的"命令式"管理，完全无视了员工的安全感诉求。' },
      { id: 'o2', text: '"调整是为了更好的资源整合，新的架构里你的技术栈其实有更大的发挥空间..."', isError: false, feedback: '✔ 成功将"被动调整"转化为"主动机会"。' }
    ]
  },
  't2': {
    id: 's2',
    description: '【离职预警】核心骨干小王最近频繁请假，周会表现抗拒。今天下午你约了他面谈。',
    practiceCount: 3421,
    accuracyRate: 82,
    options: [
      { id: 'o1', text: '直接承诺加薪 20% 挽留', isError: true, feedback: '❗ 典型的"用钱买忠诚"误区。未探明动机前的加薪会破坏薪酬体系，且对方可能拿此去下家谈更高薪。' },
      { id: 'o2', text: '直击痛点："最近状态不对，是不是觉得目前项目对个人发展没帮助？"', isError: false, feedback: '✔ 开启深度沟通的正确姿势。从职业发展切入能引导对方说出真实顾虑。' }
    ]
  },
  't3': {
    id: 's4',
    description: '【执行力差】团队新进的小李连续两次错过交付节点，且借口较多。你准备如何处理？',
    practiceCount: 1890,
    accuracyRate: 71,
    options: [
      { id: 'o1', text: '公开在群里点名批评，以儆效尤', isError: true, feedback: '❗ 这种做法会严重打击新人积极性，并营造恐惧文化，导致团队成员开始掩盖错误而非解决问题。' },
      { id: 'o2', text: '私下复盘：对齐目标、拆解任务，并要求其每日同步进度。', isError: false, feedback: '✔ 执行力差往往源于目标不清晰。建立日清机制和反馈闭环是解决新员工问题的良药。' }
    ]
  },
  't4': {
    id: 's5',
    description: '【跨部门沟通】产品部需要你团队紧急支援一个新功能，但你的团队本周已经满负荷。你如何回应？',
    practiceCount: 2456,
    accuracyRate: 58,
    options: [
      { id: 'o1', text: '直接拒绝："我们这周排满了，做不了。"', isError: true, feedback: '❗ 简单粗暴的拒绝会损害部门关系，产品部可能找上级投诉，反而让你陷入被动。' },
      { id: 'o2', text: '"这个功能确实重要，我们评估后发现本周只能抽2人支援，另外建议调整优先级..."', isError: false, feedback: '✔ 既表达了支持态度，又客观说明了资源限制，同时给出了替代方案，展现了建设性沟通姿态。' }
    ]
  },
  't5': {
    id: 's6',
    description: '【团队冲突】两位资深下属因技术方案分歧公开争执，影响了团队氛围。你如何处理？',
    practiceCount: 1876,
    accuracyRate: 69,
    options: [
      { id: 'o1', text: '召集全体大会，让两人当众辩论，民主投票决定', isError: true, feedback: '❗ 公开辩论会让矛盾升级，团队成员被迫选边站队，破坏团队凝聚力。' },
      { id: 'o2', text: '分别私下沟通，了解核心诉求，再找共同点促成妥协', isError: false, feedback: '✔ 私下沟通能了解真实想法，避免情绪化对抗，寻找双赢方案是解决资深员工冲突的关键。' }
    ]
  },
  't6': {
    id: 's7',
    description: '【目标对齐】季度目标制定时，下属普遍认为KPI定得太高，士气低落。你怎么办？',
    practiceCount: 2134,
    accuracyRate: 73,
    options: [
      { id: 'o1', text: '坚持原目标，告诉大家"压力就是动力"', isError: true, feedback: '❗ 忽视团队反馈会导致消极抵抗，最终目标难以达成，团队信任也会受损。' },
      { id: 'o2', text: '组织共创会，拆解目标到可执行路径，识别卡点并申请资源', isError: false, feedback: '✔ 让团队参与目标拆解过程，将"不可能"转化为"如何可能"，同时争取必要资源支持。' }
    ]
  },
  't7': {
    id: 's8',
    description: '【新生代管理】95后员工对重复性工作表现出明显厌倦，要求转岗。你如何应对？',
    practiceCount: 1654,
    accuracyRate: 64,
    options: [
      { id: 'o1', text: '教育他："新人都要从基础做起，不要好高骛远。"', isError: true, feedback: '❗ 用老一套说教方式对新生代无效，反而加速人才流失。' },
      { id: 'o2', text: '了解他的职业兴趣，设计轮岗计划或赋予项目ownership', isError: false, feedback: '✔ 新生代渴望成长和意义感，通过创新工作设计激发内驱力，既留住人又提升产出。' }
    ]
  },
  't8': {
    id: 's9',
    description: '【向上管理】你的上级经常临时加任务，导致团队计划频繁被打乱。你如何沟通？',
    practiceCount: 2890,
    accuracyRate: 55,
    options: [
      { id: 'o1', text: '直接抱怨："您这样加任务我们根本做不完。"', isError: true, feedback: '❗ 负面情绪的宣泄会让上级觉得你能力不够或态度有问题，影响对你的评价。' },
      { id: 'o2', text: '"老板，接到这个新任务，我盘了一下现有排期，您看哪件可以暂缓？"', isError: false, feedback: '✔ 用数据说话，让上级做选择题而非判断题，既尊重权威又保护团队产能。' }
    ]
  }
}

export const PRESCRIPTION_DATA = {
  '1': {
    truth: '执行力差的本质往往是目标不清晰或激励不到位。当团队成员出现"推一下动一下"的情况时，问题通常不在于员工的态度，而在于管理者未能将目标拆解到可执行粒度，也未能建立有效的反馈闭环。建议指挥官立即进行目标颗粒度诊断，检查每个任务是否有明确的交付标准、截止时间和验收方式。同时，建立日清机制，每日同步进度而非每周汇报，让问题暴露在24小时内而非一周后。',
    script: {
      opening: '"小王，关于这项任务，我想听听你的想法..."',
      responses: ['"目前的卡点在哪里？"', '"你需要什么资源支持？"'],
      closing: '"那我们就按这个方案推进，期待你的成果。"'
    },
    redLines: ['严禁只下指令不听反馈', '严禁模糊截止时间', '严禁用加班掩盖计划失误']
  },
  '2': {
    truth: '跨部门协作难的核心是利益不对齐和信息不对称。当对方不配合时，首先要反思自己是否站在对方角度思考问题。建议指挥官主动发起跨部门轮岗或影子观察，让双方建立体感共鸣。同时，寻找共同KPI或利益绑定点，将"你的事"变成"我们的事"。建立联合项目组和定期同步机制，让协作从"请求帮忙"变成"共同目标"。',
    script: {
      opening: '"老李，关于这个项目，我想先听听你们那边的节奏和优先级..."',
      responses: ['"我们的目标其实是一致的，都是为了提升用户体验"', '"你看这样调整会不会对你们更友好？"'],
      closing: '"太好了，那就按这个方案来，过程中有任何卡点随时同步。"'
    },
    redLines: ['严禁绕过对方直接找上级施压', '严禁只提需求不给资源支持', '严禁跨级指挥对方团队']
  },
  '3': {
    truth: '核心骨干突然离职的预警信号往往早就存在，只是管理者缺乏敏感度。真正的人才流失很少是因为薪资，更多是因为职业天花板、文化不适或成就感缺失。建议指挥官在接到离职意向的第一时间，不要急于谈钱挽留，而是发起深度职涯复盘，探寻其真实诉求。对于技术骨干，可能是技术边缘化的恐惧；对于业务骨干，可能是成长空间的焦虑。',
    script: {
      opening: '"听说你在考虑新的机会，我很重视你的想法，能聊聊是什么触发了这个决定吗？"',
      responses: ['"如果抛开薪资，现在的工作状态是你想要的吗？"', '"如果给你一个更纯粹的做事空间，你愿意再考虑吗？"'],
      closing: '"不管最终决定如何，我都会尊重。但希望你给我一个机会，让我们看看是否能一起创造你想要的成长环境。"'
    },
    redLines: ['严禁第一时间用加薪防御性挽留', '严禁威胁或情感绑架', '严禁拖延离职流程']
  },
  '4': {
    truth: '新晋管理者建立威信的关键不是"端着"，而是通过专业能力和公正处事自然赢得尊重。技术出身的管理者容易陷入"个人英雄主义"，总想证明自己比下属强。真正的威信来自于：关键时刻能带队打胜仗的专业威信，赏罚分明说到做到的制度威信，以及关心下属成长的人格威信。建议指挥官先立专业威，再建制度威，最后塑人格威。',
    script: {
      opening: '"我知道大家对我从一线转管理还有些不适应，我希望我们能一起把这个团队带成能打硬仗的铁军。"',
      responses: ['"技术上我还有些经验，管理上还需要大家多反馈"', '"关于奖金分配，我会坚持透明公开，拉开差距"'],
      closing: '"给我三个月时间，用结果说话。如果做得不好，欢迎大家随时指出。"'
    },
    redLines: ['严禁新官上任三把火烧得太急', '严禁厚此薄彼搞小圈子', '严禁不懂装懂瞎指挥']
  },
  '5': {
    truth: '会议效率低下的根源是缺乏议程管理和决策机制。大多数会议变成信息同步会，而不是决策会。建议指挥官推行"会议三不"原则：无议程不启动、无决策不散会、无纪要不留存。会前必须分发背景材料，会上严禁现场读文档。引入站立会议和计时发言机制，强制压缩无效讨论时间。让开会从"例行公事"变成"解决问题"。',
    script: {
      opening: '"今天的会议只有一个目标：确定下个月的优先级排序。"',
      responses: ['"关于这个议题，请大家15分钟内表态，不需要完美方案"', '"反对意见很重要，但请基于数据和事实"'],
      closing: '"好的，决议已明确，会议纪要今天下班前发出。没达成共识的问题我们单独拉小会。"'
    },
    redLines: ['严禁会议变成甩锅大会', '严禁让不善言辞的人当场表态', '严禁议而不决不追闭环']
  },
  '6': {
    truth: '绩效面谈的本质不是"审判过去"，而是"规划未来"。很多管理者把面谈变成了批评大会，导致员工抵触。有效的绩效面谈应该基于事实而非感受，聚焦改进而非追责。建议指挥官采用"汉堡包反馈法"：先肯定优点建立安全感，再指出具体改进点，最后表达发展信心。更重要的是，与下属共同制定下一季度的成长计划，让其感受到被投资而非被评估。',
    script: {
      opening: '"感谢你这一年的付出，今天我想先听听你对自己过去一年的评价。"',
      responses: ['"关于这个项目，数据上我们看到了明显的提升，能分享一下你是怎么做到的吗？"', '"关于下个季度的目标，你觉得什么挑战最大？我可以提供什么支持？"'],
      closing: '"不管绩效结果如何，我对你的潜力有信心。我们一起把这个发展计划落地。"'
    },
    redLines: ['严禁只谈问题不谈成绩', '严禁用模糊的形容词评价', '严禁 surprises（惊喜/惊吓）']
  },
  '7': {
    truth: '团队目标对齐不是简单的"传声筒"，而是让每个人都理解"为什么要做"和"我能贡献什么"。目标压力必须层层穿透到可执行动作，否则就会变成空洞的口号。建议指挥官组织目标共创会，让成员参与目标拆解，建立"我的目标-团队目标-公司目标"的关联感。同时设立可视化进度看板，让压力透明化而非模糊化，建立互助小组解决卡点。',
    script: {
      opening: '"下个月的战役目标已经明确了，今天我们一起来拆解，看看每个人能贡献什么。"',
      responses: ['"你觉得这个目标对你个人成长有什么帮助？"', '"如果要达成这个目标，你目前最大的卡点是什么？"'],
      closing: '"好的，目标已经对齐到每个人。记住，你不是一个人在战斗，遇到瓶颈第一时间求助。"'
    },
    redLines: ['严禁目标只下传不共创', '严禁压力只传递不解决', '严禁目标与资源不匹配']
  },
  '8': {
    truth: '管理者时间不够用的根本原因是不懂授权，事必躬亲导致团队依赖。有效的授权遵循"授能不授责"原则：提供必要资源和决策权，但责任仍由下属承担。建议指挥官用四象限法则梳理工作，将80%的事务性工作授权出去。授权时要明确目标、边界和反馈频率，但不要干预具体过程。把省下来的时间用于战略思考和人才培养。',
    script: {
      opening: '"这个项目我想交给你主导，这是对你能力的认可，也是你成长的机会。"',
      responses: ['"目标是XX，你有充分的自主权决定怎么做"', '"过程中遇到卡点随时找我，但我会尽量不干预你的决策"'],
      closing: '"我相信你能做好。成功是你的功劳，出了问题我们一起复盘，责任我来担。"'
    },
    redLines: ['严禁授权后不放心地频繁干预', '严禁只授权不赋能', '严禁授权后推卸责任']
  },
  '9': {
    truth: '识别高潜人才不能只看当前业绩，更要看学习敏锐度和成长潜力。很多管理者只关注"明星员工"，忽视了"潜力股"。高潜人才往往具备：快速学习新领域的能力、主动承担责任的意愿、以及良好的人际影响力。建议指挥官引入九宫格人才盘点，结合业绩和潜力两个维度评估。对于识别出的高潜人才，设计轮岗计划和导师制，加速其成长。',
    script: {
      opening: '"公司正在推进人才盘点，我很看好你的潜力，想听听你对自己未来发展的规划。"',
      responses: ['"如果给你一个跨部门轮岗的机会，你最想去哪里？为什么？"', '"你觉得目前哪些能力还需要提升？我可以帮你对接资源。"'],
      closing: '"你是团队重点培养的对象，接下来会有一些挑战性的任务，这是成长最快的方式。"'
    },
    redLines: ['严禁只选听话的老好人', '严禁只给机会不给支持', '严禁高潜人才流失后才后悔']
  },
  '10': {
    truth: '从技术骨干到管理者的转型，最大的障碍是心态转变：从"我做事"变成"我让人做事"。很多技术出身的管理者初期很痛苦，总想替下属写代码。建议指挥官明确：管理者的核心价值不再是解决技术难题，而是打造解决难题的团队。刻意练习非技术性沟通，学习通过目标设定和文化建设来驱动团队。建立技术分享机制，鼓励成员自主决策。',
    script: {
      opening: '"我知道从技术转管理很不容易，我自己也经历过这个阶段。"',
      responses: ['"你的核心价值现在不是写代码，而是让团队更高效地产出"', '"遇到技术难题，引导下属思考而不是直接给答案"'],
      closing: '"给自己一年时间完成这个转型，我相信你能成为一个既懂技术又懂管理的复合型人才。"'
    },
    redLines: ['严禁与下属抢功劳', '严禁 micromanagement（微观管理）', '严禁用技术权威压制不同意见']
  }
}
